import { useSpinDelay } from 'spin-delay'

const useLoadingDelay = (loading: boolean): boolean => {
  const delay = useSpinDelay(loading, {
    delay: 1000,
    minDuration: 350
  })

  return delay
}

export default useLoadingDelay
